import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { DrillLinkedService, drillAuthTypes } from 'app/model/linkedservice/drill.linkedservice';
import { DrillCopySource } from 'app/model/pipeline/copysource/drill.copysource';
import { Metamodel } from 'app/model/base/model';
import { format } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const drillMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(DrillLinkedService).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Drill_DisplayText),
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-drill'
    },
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    warningTooltip: stringResources.Connector_Legacy_IsDeprecatedHint,
    isFirstClass: true,
    category: ['Database'],
    supportDatasetV2: true,
    notShowInTypeSelection: true,
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(DrillCopySource).name],
    controls: [
        {
            type: 'select-button-switch',
            required: true,
            isLabelVertical: true,
            options: [
                {
                    label: stringResources.ModelName_ConnectionString,
                    value: false
                },
                {
                    label: stringResources.AzureKeyVault_DisplayText,
                    value: true,
                    hideAKVOptionIfNotChosen: false
                }
            ],
            bind: 'enableAKV',
            isNotRelatedToCredential: true,
            defaultValue: false,
            cases: [
                {
                    caseValue: true,
                    children: [
                        {
                            type: 'azure-key-vault',
                            bind: 'referedAKV',
                            isLabelVertical: true,
                            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template_ConnectionStringWithSample,
                                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Drill_DisplayText),
                                'ConnectionType=Direct;Host=<host>;Port=<port>;AuthenticationType=Plain;UID=<user name>;PWD=<password>')
                        }
                    ]
                },
                {
                    caseValue: false,
                    children: [
                        {
                            type: 'textbox',
                            bind: 'host',
                            label: stringResources.ModelName_Host,
                            required: true,
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ],
                            isLabelVertical: true
                        },
                        {
                            type: 'textbox',
                            bind: 'port',
                            label: stringResources.ModelName_Port,
                            isLabelVertical: true,
                            inputType: 'number',
                            min: 0
                        },
                        {
                            type: 'select-switch',
                            bind: 'authenticationType',
                            label: stringResources.ModelName_AuthenticationType,
                            required: true,
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ],
                            isLabelVertical: true,
                            options: [
                                {
                                    label: stringResources.AuthenticationType_NoAuthentication,
                                    value: drillAuthTypes.NoAuthentication
                                },
                                {
                                    label: stringResources.AuthenticationType_Plain,
                                    value: drillAuthTypes.Plain
                                }
                            ],
                            defaultValue: drillAuthTypes.NoAuthentication,
                            cases: [
                                {
                                    caseValue: drillAuthTypes.Plain,
                                    children: [
                                        {
                                            type: 'textbox',
                                            bind: 'userName',
                                            label: stringResources.ModelName_UserName,
                                            required: true,
                                            validators: [
                                                { type: 'required', errorMessage: '' }
                                            ],
                                            isLabelVertical: true
                                        },
                                        {

                                            type: 'dynamic-akv-switcher',
                                            hideAKVSwitcherInConnStrProps: true,
                                            bind: 'password',
                                            label: stringResources.ModelName_Password,
                                            child: {
                                                type: 'password',
                                                label: stringResources.ModelName_Password,
                                                required: true,
                                                isLabelVertical: true,
                                                validators: [
                                                    { type: 'required', errorMessage: '' }
                                                ]
                                            },
                                            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                                                stringResources.Drill_DisplayText,
                                                stringResources.ModelName_Password)
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'key-val-list',
                            bind: 'additionalFields',
                            label: stringResources.AdditionalConnectionStringFields
                        }
                    ]
                }
            ]
        }
    ]
};
